import { gql } from '@apollo/client';

export const RESET_PASSWORD = gql`
  query resetPassword($data: ResendTemporaryPasswordInput!) {
    resetPassword(data: $data)
  }
`;
